
import CalendarNavigation from './CalendarNavigation';

interface CalendarHeaderProps {
  title: string;
  subtext: string;
  currentDate: Date;
  setCurrentDate: (date: Date) => void;
  checkInDate?: Date;
  checkOutDate?: Date;
  onSelectionCleared?: () => void;
  isMobile: boolean;
}

const CalendarHeader = ({ 
  title, 
  subtext, 
  currentDate, 
  setCurrentDate, 
  checkInDate, 
  checkOutDate, 
  onSelectionCleared, 
  isMobile 
}: CalendarHeaderProps) => {
  return (
    <>
      <div className="flex items-center justify-between mb-2" data-calendar-title id="calendar-title">
        <h3 className="text-xl font-semibold">{title}</h3>
        
        <CalendarNavigation
          currentDate={currentDate}
          setCurrentDate={setCurrentDate}
          checkInDate={checkInDate}
          checkOutDate={checkOutDate}
          onSelectionCleared={onSelectionCleared}
          isMobile={isMobile}
        />
      </div>

      <div className="mb-6">
        <p className={`${checkInDate && checkOutDate ? 'text-brand-primary' : 'text-gray-600'}`}>
          {subtext}
        </p>
      </div>
    </>
  );
};

export default CalendarHeader;